/**
 * AutoCount - Vehicles List Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

const sampleVehicles = [
  { year: 2024, make: "Toyota", model: "Camry", trim: "SE", engine: "2.5L I4", bodyType: "Sedan" },
  { year: 2024, make: "Toyota", model: "RAV4", trim: "XLE", engine: "2.5L I4", bodyType: "SUV" },
  { year: 2024, make: "Honda", model: "Accord", trim: "Sport", engine: "1.5L I4 Turbo", bodyType: "Sedan" },
  { year: 2024, make: "Honda", model: "CR-V", trim: "Touring", engine: "1.5L I4 Turbo", bodyType: "SUV" },
  { year: 2024, make: "Ford", model: "F-150", trim: "XLT", engine: "3.5L V6 EcoBoost", bodyType: "Truck" },
  { year: 2024, make: "Ford", model: "Mustang", trim: "GT", engine: "5.0L V8", bodyType: "Coupe" },
];

function VehiclesList(): JSX.Element {
  const navigate = useNavigate();
  const columns = [
    { Header: "Year", accessor: "year", width: "10%" },
    { Header: "Make", accessor: "make", width: "15%" },
    { Header: "Model", accessor: "model", width: "15%" },
    { Header: "Trim", accessor: "trim", width: "15%" },
    { Header: "Engine", accessor: "engine", width: "20%" },
    { Header: "Body Type", accessor: "bodyType", width: "15%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Vehicles Database
                </MDTypography>
                <MDButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={() => navigate("/vehicles/add")}
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Add Vehicle
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows: sampleVehicles }}
                  isSorted={true}
                  entriesPerPage={{ defaultValue: 10, entries: [5, 10, 25, 50] }}
                  showTotalEntries={true}
                  canSearch={true}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VehiclesList;
